module.exports = __webpack_public_path__ + "static/img/sdgs_my_bottle_ttl.44d5a0b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/company/sdgs_my_bottle_ttl.svg
// module id = VpYc
// module chunks = 0